export default "__VITE_ASSET__CVI0YUrM__"